import { render } from "./PageHeadline.vue?vue&type=template&id=2474eb50&scoped=true&ts=true"
import script from "./PageHeadline.vue?vue&type=script&lang=ts"
export * from "./PageHeadline.vue?vue&type=script&lang=ts"

import "./PageHeadline.vue?vue&type=style&index=0&id=2474eb50&lang=scss&scoped=true"

import exportComponent from "D:\\_dev\\engenious-pl\\public-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2474eb50"]])

export default __exports__